export default __webpack_public_path__ + "static/media/icon_book_caligrafix_platform_blue.bfc05f22.svg";